// src/core/api/contactApi.js
import { axiosClient } from "./axiosClient";

export const contactApi = {
  list: async () => {
    const res = await axiosClient.get("/contact/");
    return res.data;
  },

  detail: async (id) => {
    const res = await axiosClient.get(`/contact/${id}/`);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await axiosClient.patch(`/contact/${id}/`, payload);
    return res.data;
  },

  remove: async (id) => {
    await axiosClient.delete(`/contact/${id}/`);
  },
};
